<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // this.$nextTick(() => {
    //     // 禁用右键
    //     // document.oncontextmenu = new Function("event.returnValue=false");
    //     // 禁用选择
    //     document.onselectstart = new Function("event.returnValue=false");
    //   });
  }
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
}
.el-table th.gutter {
  display: table-cell !important;
}
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.number__input {
  border: 1px solid #ccc;
}
.el-select {
  width: 100%;
}
.selectInput .el-select .el-input__inner {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
/* .el-dialog .el-select{
  width: 50%;
} */
.el-table .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
.pad-22 {
  padding: 1px 21px;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group,
.el-table--border th,
.el-table__fixed-right-patch {
  border-color: rgba(0, 0, 0, 0.1) !important;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.auditInformation {
  padding: 15px 44px 50px;
  background: #fff;
}
.bg-purple-dark {
  line-height: 30px;
  text-indent: 22px;
  font-size: 14px;
  color: #179cd5;
  font-weight: 600;
}
.ax_default {
  height: 65px;
  width: 100%;
  background-color: rgba(242, 242, 242, 1);
  margin: 10px auto 0;
  line-height: 65px;
  font-weight: 700;
  font-size: 18px;
  text-indent: 22px;
}
.el-input-number .el-input__inner{
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue